<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h100-40 h-scroll license_bg">
        <NmsLicense v-show="type==1"></NmsLicense>
        <DeviceLicense v-show="type==2"></DeviceLicense>
      </div>
    </template>
  </BasicLayout>
</template>
<script>
import BasicLayout from '../../layouts/BasicLayout'
import NmsLicense from '../../components/security/licenseManager/nmsLicense'
import DeviceLicense from '../../components/security/licenseManager/deviceLicense'

export default {
  name: 'LicenseManager',
  data() {
    return {
      left: { show: false, name: '' },
      middle: { show: false, name: '' },
      right: {
        show: true,
        crumb: `${this.$t('Security.securityManage')}`+ '/' + `${this.$t('Security.LicenseManage')}` + '/'
        + (this.$route.params.id==1?'UNMS':`${this.$t('Security.device')}`) },
      type: this.$route.params.id
    }
  },
  components: {
    BasicLayout,
    NmsLicense,
    DeviceLicense
  },
  watch: {
    $route(to, from) {
      this.type = this.$route.params.id
      this.right.crumb = `${this.$t('Security.securityManage')}`+ '/' + `${this.$t('Security.LicenseManage')}` + '/'
        + (this.$route.params.id==1?'UNMS':`${this.$t('Security.device')}`)
    }
  }
}
</script>
<style scoped>
  .license_bg {
    background-color: #fff;
  }
</style>

